import axios from 'axios';
import { DHLError, axiosRequest, handleHttpResponse } from '@general/js/utils';
import Services from '@general/js/services/Services';
import { getCurrentDate } from '@general/js/utils/dateTimeUtils';
import AbstractClass from './CommonAbstractServices';

export default class CommonServices extends AbstractClass {
  static async getBusinessHours() {
    try {
      const response = await axios.get(Services.COMMON.GET_BUSINESS_HOURS);
      if (handleHttpResponse(response) && response?.data?.openingTimes) {
        return response.data.openingTimes;
      }

      throw new DHLError(`Unexpected data structure returned for data: ${JSON.stringify(response.data)}`);
    } catch (error) {
      throw new DHLError(`getBusinessHours() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  static async getSearchPrediction(searchText) {
    try {
      const response = await axiosRequest().get(Services.COMMON.GET_SEARCH_PREDICTION, { params: { searchText } });

      if (handleHttpResponse(response) && response?.data?.suggestions) {
        return response.data.suggestions;
      }
      throw new DHLError(`Unexpected data structure returned for data: ${JSON.stringify(response.data)}`);
    } catch (error) {
      throw new DHLError(`getSearchPrediction() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  static async uploadRebateFormPdf(memberNumber, fileName, b64EncodedFile) {
    try {
      const ddmmyyyy = getCurrentDate().split('-').reverse().join('');
      const response = await axiosRequest().post(Services.COMMON.POST_REBATE_FORM_UPLOAD(memberNumber, `${fileName}-${ddmmyyyy}`, ddmmyyyy), { fileBody: b64EncodedFile });

      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`uploadRebateFormPdf() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }
}
